import {createSlice} from '@reduxjs/toolkit'
import moment from 'moment'

const tutorialVideo = createSlice({
  name: 'tutorialVideo',
  initialState: {
    isModalOpen: false,
    canOpenAt: null,
  },
  reducers: {
    openModal: (state, {payload: forceOpen}) => {
      if (state.canOpenAt == null || forceOpen) {
        state.isModalOpen = true
      } else if (moment().isAfter(state.canOpenAt)) {
        state.isModalOpen = true
        state.canOpenAt = null
      }
    },
    closeModal: (state, {payload: addDuration}) => {
      // payload should be of type DurationInputObject, ex. {days: 7}
      // More info: https://momentjscom.readthedocs.io/en/latest/moment/03-manipulating/01-add/
      state.isModalOpen = false
      if (addDuration) {
        state.canOpenAt = moment().add(moment.duration(addDuration)).toISOString()
      }
    },
  },
})

export const {openModal, closeModal} = tutorialVideo.actions

export default tutorialVideo
